import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-freestyle.js';
const html = `
<div class="container container-freestyle" data-attribute="content">
  <p style="text-align:center;">
    <strong>End of season</strong><span style="color:hsl(0, 75%, 60%);"><strong> sale up to 71%</strong></span>
  </p>
</div>
`;
export default containerFuild(html, css, {
  topPadding: false,
  bottomPadding: false,
  backgroundColor: '#000000',
  textColor: '#FFFFFF',
});
